import { createElementVNode as _createElementVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/componentImg/video-play.png';
import _imports_1 from '@/assets/componentImg/video-replay.png';

const _withScopeId = n => (_pushScopeId("data-v-6b76b912"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "video-container"
};
const _hoisted_2 = {
  class: "video-box"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "play-btn",
  src: _imports_0,
  alt: ""
};
const _hoisted_5 = {
  class: "play-btn replay-btn",
  src: _imports_1,
  alt: ""
};
const _hoisted_6 = {
  class: "info-mask"
};
const _hoisted_7 = {
  class: "name"
};
const _hoisted_8 = {
  class: "author-text-wrap"
};
const _hoisted_9 = {
  class: "text-desc"
};
import { ref, onMounted } from 'vue';
import composition from '@/composition';
import CImage from '@/components/common/cimage.vue';
import ua from '@/utils/platform';
export default {
  props: {
    postItem: Object
  },

  setup(__props) {
    const props = __props;
    const {
      openApp
    } = composition();
    const video = ref(props.postItem.videos[0]);
    const playState = ref(0);

    const play = () => {
      if (playState.value != 1) {
        document.getElementsByClassName('video')[0].play();
        playState.value = 1;
      } else {
        document.getElementsByClassName('video')[0].pause();
        playState.value = 2;
      }
    }; // [埋点] 帖子视频播放一次上报一次


    const pocVideoPlay = (item = props.postItem) => {
      const isMini = ua.isMini;
      const eventName = isMini ? 'fsplusmp_post_video_play' : 'fsplush5_post_video_play';
      let _poc_event_params = {
        button_name: isMini ? '帖子详情页' : undefined,
        // 内嵌小程序时才上报此字段
        content_id: item.id,
        user_code: item.memberId,
        author_name: item.memberNickname
      }; // eslint-disable-next-line no-undef

      qaplus.event.record(eventName, 19999, _poc_event_params); // eslint-disable-next-line no-undef

      pocplus.event.record(eventName, _poc_event_params);
    };

    const overText = ref(0);
    onMounted(() => {
      const descDom = document.getElementsByClassName('text-desc')[0];

      if (descDom.scrollHeight > descDom.offsetHeight) {
        // 需要展示 展开按钮
        overText.value = 1;
      } // 播放事件


      document.getElementsByClassName('video')[0].addEventListener('play', function () {
        pocVideoPlay();
      });
      document.getElementsByClassName('video')[0].addEventListener('ended', () => {
        playState.value = 3;
      }, false);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        onClick: play
      }, [_createElementVNode("video", {
        class: "video absolute-fill",
        preload: "metadata",
        playsinline: "",
        src: video.value.filePath,
        "x5-video-player-type": "h5",
        "x5-video-player-fullscreen": "true"
      }, null, 8, _hoisted_3), _withDirectives(_createElementVNode("div", {
        class: "poster absolute-fill",
        style: _normalizeStyle({
          'background-image': `url(${video.value.coverPath})`
        })
      }, null, 4), [[_vShow, playState.value == 0]]), _withDirectives(_createElementVNode("img", _hoisted_4, null, 512), [[_vShow, playState.value == 0 || playState.value == 2]]), _withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [[_vShow, playState.value == 3]])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
        class: "user-wrap",
        onClick: _cache[1] || (_cache[1] = $event => _unref(openApp)())
      }, [_createVNode(CImage, {
        class: "head-pic",
        src: __props.postItem.memberPhoto
      }, null, 8, ["src"]), _createElementVNode("p", _hoisted_7, _toDisplayString(__props.postItem.memberNickname), 1), _createElementVNode("div", {
        class: "follow-btn",
        onClick: _cache[0] || (_cache[0] = $event => _unref(openApp)())
      })]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_withDirectives(_createElementVNode("i", {
        class: "text-trigger",
        onClick: _cache[2] || (_cache[2] = $event => _unref(openApp)())
      }, "展开", 512), [[_vShow, overText.value]]), _createTextVNode(" " + _toDisplayString(__props.postItem.content), 1)])])])])]);
    };
  }

};